module.exports = __webpack_public_path__ + "img/cnpee_nou44.aa837fce.png";